import { render } from "./DefImg.vue?vue&type=template&id=78c7dc3c&scoped=true"
import script from "./DefImg.vue?vue&type=script&lang=js"
export * from "./DefImg.vue?vue&type=script&lang=js"

import "./DefImg.vue?vue&type=style&index=0&id=78c7dc3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c7dc3c"]])

export default __exports__